import React from 'react';
import classes from './GetJoinLinkPopupForm.module.css';
import CloseIcon from "../../../assets/icons/icon-close-black.png";
import FlexModal from '../../UI/FlexModal/FlexModal';

class GetJoinLinkPopupForm extends React.Component {
    render() {
        return (
            <FlexModal visible={true} forSessionPlanForm={true} fullScreenMobile={true} backdropClicked={() => this.props.closePopup('')}>
                <div className={classes.Form}>
                    <h5 className={classes.Heading}>Get Joining Link</h5>
                    <img src={CloseIcon} alt={'Hide form'} className={classes.CloseIcon}
                        onClick={this.props.closePopup} />
                    <div>
                        <h4 className={classes.Title}>Participants Link:</h4>
                        <div className={classes.Full}>
                            {this.props.data.liveSessionList[0].meetId ?
                                <a href={"https://zekelabs.zoom.us/j/" + this.props.data.liveSessionList[0].meetId + "?pwd=" + this.props.data.liveSessionList[0].encPassword} target="_blank" rel="noopener noreferrer">
                                    https://zekelabs.zoom.us/j/{this.props.data.liveSessionList[0].meetId}?pwd={this.props.data.liveSessionList[0].encPassword}
                                </a>
                                : <p>Live Session is not started yet.</p>}
                        </div>
                    </div>
                    <div>
                        <h4 className={classes.Title}>Host Link:</h4>
                        <div className={classes.Full}>
                            {this.props.data.liveSessionList[0].startURL ? <a href={this.props.data.liveSessionList[0].startURL} target="_blank" rel="noopener noreferrer">
                                {this.props.data.liveSessionList[0].startURL}
                            </a> :
                                <p>Live Session is not started yet.</p>}
                        </div>
                    </div>
                </div>
            </FlexModal>
        );
    }

}

export default GetJoinLinkPopupForm;